import { render } from "./SectionCard.vue?vue&type=template&id=26f33a6f"
import script from "./SectionCard.vue?vue&type=script&lang=js"
export * from "./SectionCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/LCAP/LCAP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__